import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { Popover, OverlayTrigger, Row, Col, Table } from "react-bootstrap";
import { ConsultaDeudaEst } from '../../../funciones/EstCuentaFunction';
import { consultaSolicitudInd, GenerarSolicitudInd } from '../../../funciones/ConstanciaFunction';
import DatePicker from 'react-date-picker';

import CustomModal from "../../../components/Modal/CustomModal";
import MensajeRetrasoInd from "../../../shared/MensajeRetrasoInd";
import ModalReports from '../../../components/Reportes/ModalReports';
import CartaEgreso from '../../../components/Reportes/CartaEgreso';
import CargaHoraria from '../../../components/Reportes/CargaHoraria';
import Pensum from '../../../components/Reportes/Pensum';
import ModEstudioSimple from '../../../components/Reportes/ModEstudioSimple';
import ModEstudioCert from '../../../components/Reportes/ModEstudioCert';
import CulminacionEstS from '../../../components/Reportes/CulminacionEstS';
import CulminacionEstCertS from '../../../components/Reportes/CulminacionEstCertS';
import ConsConductaCert from '../../../components/Reportes/ConsConductaCert';

let statusBtn = 0;
let token = "";
let fecha = "";
let deudaTSolic = "";
let fechaS = new Date();

class EstudiantesSolicitudesTable extends Component {
    state = {
        button: {
            icon: "fa fa-file-text",
            text: "Imprimir"
        },
        status: {
            icon: "fa fa-spinner fa-spin",
            text: "Verificando, espera por favor",
            class: "custom-alert-info",
            styles:{fontSize:12, position:"absolute", top: 4}
        },
        constancias: [],
        datosEst:"",
        openW:false,
        qr: "",
        text1: "",
        text2: "",
        text3: "",
        textFecha: fechaS,
        large: "medium",
        openOk: false,
        modalBtn1: {
            icon:"fa fa-check",
            text: "Si"
        },
    }

    constructor (props) {
        super (props);
        consultaSolicitudInd (this.props.data.id_estudiante, this.props.tipo, (resp) => {
            statusBtn = resp[3]
            this.setState({
                status: resp[0],
                constancias: resp[1],
                datosEst: resp[2]
            })
        })
    }

    componentDidMount = () => {
        ConsultaDeudaEst (this.props.data.id_estudiante, (resp) => {
            deudaTSolic = resp.deudaVencida
            switch(this.props.tipo){
                case "Constancia de Culminación de Estudios (Simple)":
                    this.setState ({
                        large: "large",
                        deudaT: resp.deudaVencida
                    })
                break;
                case "Constancia de Culminación de Estudios (Certificada)":
                    this.setState ({
                        large: "large",
                        deudaT: resp.deudaVencida
                    })
                break;
                default:
                    this.setState ({
                        large: "medium",
                        deudaT: resp.deudaVencida
                    })
                break;
            }
        })
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]: event.target.value 
        });
    };

    cambiaFecha = (date) => {
        this.setState({ textFecha: date });
    }

    modal = () => {
        let {text1, text2, text3, textFecha} = this.state;
        if (this.state.openW === false) return null
        let rep = "";
        switch(this.props.tipo){
            case "Carta de Egreso": 
                rep = <CartaEgreso
                    datos= {this.state.datosEst}
                    token = {token}
                    fecha = {fecha}
                />
            break;
            case "Carga Horaria":
                rep = <CargaHoraria
                    datos= {this.state.datosEst}
                    token = {token}
                    fecha = {fecha}
                />
            break;
            case "Certificación Plan de Estudios (Pensum)":
                rep = <Pensum
                    datos= {this.state.datosEst}
                    token = {token}
                    fecha = {fecha}
                />
            break;
            case "Constancia de Modalidad de Estudio (Simple)":
                rep = <ModEstudioSimple
                    datos= {this.state.datosEst}
                    token = {token}
                    fecha = {fecha}
                />
            break;
            case "Constancia de Modalidad de Estudio (Certificada)":
                rep = <ModEstudioCert
                    datos= {this.state.datosEst}
                    token = {token}
                    fecha = {fecha}
                />
            break;
            case "Constancia de Culminación de Estudios (Simple)":
                rep = <CulminacionEstS
                    datos= {this.state.datosEst}
                    token = {token}
                    fecha = {fecha}
                    numero = {text1}
                    folio = {text2}
                    tomo = {text3}
                    fechaDoc = {textFecha}
                />
            break;
            case "Constancia de Culminación de Estudios (Certificada)":
                rep = <CulminacionEstCertS
                    datos= {this.state.datosEst}
                    token = {token}
                    fecha = {fecha}
                    numero = {text1}
                    folio = {text2}
                    tomo = {text3}
                    fechaDoc = {textFecha}
                />
            break;
            case "Constancia de Buena Conducta (Certificada)":
                rep = <ConsConductaCert
                    datos= {this.state.datosEst}
                    token = {token}
                    fecha = {fecha}
                />
            break;
            default:
                rep = "";
            break;
        }

        return (
            <ModalReports
                reporte={rep}
                titulo={`Impresión de ${this.props.tipo}`}
                display= "block"
                cerrar = {() => {this.setState({openW:false})}}
            />
        )
    }

    modalOk = () => {
        const { openOk, modalBtn1, text1, text2, text3, textFecha, large } = this.state;

        let Aceptar = () => () => {
            switch(this.props.tipo){
                case "Constancia de Culminación de Estudios (Simple)":
                    switch(true){
                        case(text1 === ""):
                            toast.error("Debes ingresar el Número",{autoClose: 4000});
                        break;
                        case(text2 === ""):
                            toast.error("Debes ingresar el Numero del Folio",{autoClose: 4000});
                        break;
                        case(text3 === ""):
                            toast.error("Debes ingresar el Tomo",{autoClose: 4000});
                        break;
                        case(textFecha === ""):
                            toast.error("Debes ingresar la Fecha",{autoClose: 4000});
                        break;
                        default:
                            this.procesaConstancia()
                        break;
                    }
                break;
                case "Constancia de Culminación de Estudios (Certificada)":
                    switch(true){
                        case(text1 === ""):
                            toast.error("Debes ingresar el Número",{autoClose: 4000});
                        break;
                        case(text2 === ""):
                            toast.error("Debes ingresar el Numero del Folio",{autoClose: 4000});
                        break;
                        case(text3 === ""):
                            toast.error("Debes ingresar el Tomo",{autoClose: 4000});
                        break;
                        case(textFecha === ""):
                            toast.error("Debes ingresar la Fecha",{autoClose: 4000});
                        break;
                        default:
                            this.procesaConstancia()
                        break;
                    }
                break;
                default:
                    this.procesaConstancia()
                break;
            }
        }

        let contenido = () => {
            switch(this.props.tipo){
                case "Constancia de Culminación de Estudios (Simple)": return (
                    <React.Fragment>
                        <div className="text-danger" style = {{fontSize: 12, marginBottom:10}}><strong>Esta Constancia requiere información adicional. Por favor completa los siguientes campos:</strong></div>
                        <Row>
                            <Col md = {2}>
                                <div style = {{fontSize: 10}}>Número:</div>
                                <input type = "text" value = {text1} onChange = {this.cambiaValor("text1")} className = "form-control" placeholder = "N°"/>
                            </Col>
                            <Col md = {2}>
                                <div style = {{fontSize: 10}}>Folio:</div>
                                <input type = "text" value = {text2} onChange = {this.cambiaValor("text2")} className = "form-control" placeholder = "Folio"/>
                            </Col>
                            <Col md = {2}>
                                <div style = {{fontSize: 10}}>Tomo:</div>
                                <input type = "text" value = {text3} onChange = {this.cambiaValor("text3")} className = "form-control" placeholder = "Tomo"/>
                            </Col>
                            <Col md = {6}>
                                <div style = {{fontSize: 10}}>Fecha:</div>
                                <DatePicker
                                    clearIcon= {<i className="fa fa-times"></i>}
                                    calendarIcon= {<i className="fa fa-calendar"></i>}
                                    className="form-control"
                                    onChange={this.cambiaFecha}
                                    value={textFecha}
                                />
                            </Col>
                        </Row>
                        <div className="custom-mt-10" style = {{fontSize: 12}}>Vas a proceder a <strong className="text-primary">Montar</strong> el formato de <strong>{this.props.tipo}</strong>. Si presionas <strong>Si</strong> se cargará el formato para imprimir. ¿Deseas continuar?</div>
                    </React.Fragment>
                )
                case "Constancia de Culminación de Estudios (Certificada)": return (
                    <React.Fragment>
                        <div className="text-danger" style = {{fontSize: 12, marginBottom:10}}><strong>Esta Certificación requiere información adicional. Por favor completa los siguientes campos:</strong></div>
                        <Row>
                            <Col md = {2}>
                                <div style = {{fontSize: 10}}>Número:</div>
                                <input type = "text" value = {text1} onChange = {this.cambiaValor("text1")} className = "form-control" placeholder = "N°"/>
                            </Col>
                            <Col md = {2}>
                                <div style = {{fontSize: 10}}>Folio:</div>
                                <input type = "text" value = {text2} onChange = {this.cambiaValor("text2")} className = "form-control" placeholder = "Folio"/>
                            </Col>
                            <Col md = {2}>
                                <div style = {{fontSize: 10}}>Tomo:</div>
                                <input type = "text" value = {text3} onChange = {this.cambiaValor("text3")} className = "form-control" placeholder = "Tomo"/>
                            </Col>
                            <Col md = {6}>
                                <div style = {{fontSize: 10}}>Fecha:</div>
                                <DatePicker
                                    clearIcon= {<i className="fa fa-times"></i>}
                                    calendarIcon= {<i className="fa fa-calendar"></i>}
                                    className="form-control"
                                    onChange={this.cambiaFecha}
                                    value={textFecha}
                                />
                            </Col>
                        </Row>
                        <div className="custom-mt-10" style = {{fontSize: 12}}>Vas a proceder a <strong className="text-primary">Montar</strong> el formato de <strong>{this.props.tipo}</strong>. Si presionas <strong>Si</strong> se cargará el formato para imprimir. ¿Deseas continuar?</div>
                    </React.Fragment>
                )
                default: return (
                    <React.Fragment>
                        <div>Vas a proceder a <strong className="text-primary">Montar</strong> el formato de <strong>{this.props.tipo}</strong>. Si presionas <strong>Si</strong> se cargará el formato para imprimir. ¿Deseas continuar?</div>
                    </React.Fragment>
                )
            }
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalBtn1.icon}></i> {modalBtn1.text}</React.Fragment>}
                large = {large}
                isopen =  {openOk}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = { Aceptar() }
                funcion2 = { () => {this.setState({openOk: false}) }}
            />
        );
    }

    procesaConstancia = () => {
        this.setState({
            button: {
                icon: "fa fa-spinner fa-spin",
                text: "Imprimir"
            },
            modalBtn1: {
                icon:"fa fa-spinner fa-spin",
                text: "Generando el Formato"
            }
        }, () => {
            GenerarSolicitudInd(this.props.data.id_estudiante, this.props.tipo, (resp) => {
                let data = JSON.parse(resp)
                token = data.token
                fecha = data.fecha
                this.setState({
                    button: {
                        icon: "fa fa-file-text",
                        text: "Imprimir"
                    },
                    openW:true,
                    openOk: false
                }, () => {
                    consultaSolicitudInd (this.props.data.id_estudiante, this.props.tipo, (resp) => {
                        statusBtn = resp[3]
                        this.setState({
                            status: resp[0],
                            constancias: resp[1],
                        })
                    })
                })
            })
        })
    }

    botones = () => {
        let { button } = this.state;
        switch (statusBtn) {
            case 0:
                if (deudaTSolic > 0) {
                    let contenidoD = () => (
                        <Popover bsSize="large" id="Inscrito">
                            <MensajeRetrasoInd />
                        </Popover>
                    )
                    
                    return (
                        <OverlayTrigger ref="overlay" trigger="focus" placement="right" overlay={contenidoD()}>
                            <button className="btn btn-primary" style={{borderWidth: 1}}><i className={button.icon}></i> {button.text}</button>
                        </OverlayTrigger>
                    )
                }

                return (
                    <button className="btn btn-primary" onClick = {() => {this.setState({openOk: true})}} style={{borderWidth: 1}}><i className={button.icon}></i> {button.text}</button>
                )
            case 1:
                    let contenido = (
                        <Popover bsSize="large" id="Inscrito">
                            <div className="custom-alert-danger" align="center">Estudiante no inscrito</div>
                            <div align="justify" className="custom-mt-10">
                                Este estudiante no ha formalizado su inscripción
                            </div>
                        </Popover>
                    )
    
                    return (
                        <div className="btn-group" role="group">
                            <OverlayTrigger trigger="focus" placement="right" overlay={contenido}>
                                <button style={{borderWidth: 1}} className="btn btn-primary"><i className={button.icon}></i> {button.text}</button>
                            </OverlayTrigger>
                        </div>
                    )
            case 2:
                let contenido2 = (
                    <Popover bsSize="large" id="Inscrito">
                        <div className="custom-alert-danger" align="center">Importante</div>
                        <div align="justify" className="custom-mt-10">
                            La inscripción de este estudiante aún no está aprobada.
                        </div>
                    </Popover>
                )

                return (
                    <div className="btn-group" role="group">
                        <OverlayTrigger trigger="focus" placement="right" overlay={contenido2}>
                            <button style={{borderWidth: 1}} className="btn btn-primary"><i className={button.icon}></i> {button.text}</button>
                        </OverlayTrigger>
                    </div>
                )
            default:
                }return (
                    <button className="btn btn-primary" style={{borderWidth: 1}}><i className="fa fa-times" title="Presiona F5 para refrescar esta página"></i> Error al Cargar</button>
                )
    }

    render() { 
        const styles = {
            padding: 5, fontSize: 12
        }
        let nombre2 = this.props.data.nombre_2;
        let apellido2 = this.props.data.apellido_2;
        if (nombre2 === null) nombre2 = "";
        if (apellido2 === null) apellido2 = "";
        let nombreCompleto = `${this.props.data.nombre_1} ${nombre2} ${this.props.data.apellido_1} ${apellido2}`

        return (
            <React.Fragment>
                <tr>
                    <td align="center" style={styles}>{`${this.props.data.nacionalidad} ${this.props.data.ci}`}</td>
                    <td style={styles}>{nombreCompleto}</td>
                    <td align="center" style={styles}>{this.props.data.carrera_name}</td>
                    <td align="center" style={styles}>
                        {this.botones()}
                    </td>
                </tr>
                {this.modal()}
                {this.modalOk()}
            </React.Fragment>
            
        );
    }
}
 
export default EstudiantesSolicitudesTable;


// WEBPACK FOOTER //
// ./src/views/Reportes/SolicitudesContent/EstudiantesSolicitudesTable.jsx